// src/pages/Career.js
import axios from "axios";
import React, { useEffect, useState } from "react";
import JobManagement from "../Components/JobManagement";
import career from "../Assets/career.jpeg";
import CardLoader from "../Components/Loader/CardLoader";

const API = "http://localhost:5000";

const Career = () => {
  const [jobData, setJobData] = useState([]);
  const [showForm, setShowForm] = useState(false);

  // 🔹 Added state for selected job position
  const [selectedPosition, setSelectedPosition] = useState("");

  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    joiningDate: "",
    currentCTC: "",
    expectedCTC: "",
    shift: "",
    experience: "",
    source: "",
    reason: "",
  
    resume: null,
    position: "", // keep position in formData
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // 🔹 Sync position when selected
  useEffect(() => {
    if (selectedPosition) {
      
      setFormData((prev) => ({ ...prev, position: selectedPosition }));
    }
  }, [selectedPosition]);

  // Validation
  const validateField = (name, value) => {
    switch (name) {
      case "fullName":
        return value.trim() ? "" : "Full name is required";
      case "phone":
        return /^[0-9]{10}$/.test(value) ? "" : "Phone must be 10 digits";
      case "email":
        return /\S+@\S+\.\S+/.test(value) ? "" : "Invalid email address";
      case "joiningDate":
        return value ? "" : "Joining date is required";
      default:
        return "";
    }
  };

  // Handle change
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setFormData({ ...formData, resume: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
      setErrors({ ...errors, [name]: validateField(name, value) });
    }
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate all fields
    let newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (key !== "resume") {
        const error = validateField(key, formData[key]);
        if (error) newErrors[key] = error;
      }
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    try {
      setLoading(true);

      // Build FormData for file
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        if (formData[key]) {
          data.append(key, formData[key]);
        }
      });

      const res = await axios.post(`${API}/api/recruit`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      console.log("Form Submitted ✅", res.data);
      alert("Application submitted successfully!");

      // Reset form
      setFormData({
        fullName: "",
        phone: "",
        email: "",
        joiningDate: "",
        currentCTC: "",
        expectedCTC: "",
        shift: "",
        experience: "",
        source: "",
        reason: "",
        coverLetter: "",
        resume: null,
        position: "",
      });
      setSelectedPosition("");
      setShowForm(false);
    } catch (err) {
      console.error(err);
      alert("❌ Failed to submit application. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch jobs
  const fetchJobPost = async () => {
    try {
      const res = await axios.get(`${API}/api/jobs`);
      const jobs = res.data;
      const consultancyJobs = jobs.filter((job) => job.type === "career");
      setJobData(consultancyJobs);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchJobPost();
  }, []);

  return (
    <div className="cs-container">
      {/* Header */}
      <header
        className="cs-header"
        style={{
          background: `url(${career})`,
          backgroundPosition: "center",
          minHeight: "50vh",
          backgroundSize: "cover",
        }}
      >
        <h1 className="cs-title">Careers at STS</h1>
        <p className="cs-subtitle">
          Join STS and be part of a dynamic team that’s shaping the future of
          training, skill development, and placements.
        </p>
      </header>

      {/* Job Section */}
      <section className="cs-section">
        <button
          className="cs-btn"
          onClick={() => {
            setSelectedPosition(""); // General apply
            setShowForm(true);
          }}
        >
          Start with Us
        </button>
      </section>

      {jobData.length > 0 ? (
        <JobManagement
          jobs={jobData}
          setShowForm={setShowForm}
          setSelectedPosition={setSelectedPosition}
        />
      ) : (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <CardLoader />
          <CardLoader />
          <CardLoader />
        </div>
      )}

      {/* Popup Form */}
      {showForm && (
        <div className="cs-modal">
          <div className="cs-modal-content">
            <h2 className="cs-form-heading">Apply Now</h2>

            {/* Auto Position */}
            {/* {formData.position && (
              <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
                Position: {formData.position}
              </p>
            )} */}

            <form onSubmit={handleSubmit} className="cs-form">
              <div className="scroll-cs">
                {/* Basic fields */}
                {[
                  { label: "Full Name *", name: "fullName", type: "text" },
                  { label: "Phone Number *", name: "phone", type: "tel" },
                  { label: "Email *", name: "email", type: "email" },
                  {
                    label: "Expected Joining Date *",
                    name: "joiningDate",
                    type: "date",
                  },
                ].map((field, idx) => (
                  <div key={idx}>
                    <label>{field.label}</label>
                    <input
                      type={field.type}
                      name={field.name}
                      value={formData[field.name]}
                      min={
                        field.type === "date"
                          ? new Date().toISOString().split("T")[0]
                          : undefined
                      }
                      onChange={handleChange}
                    />
                    {errors[field.name] && (
                      <span className="cs-error">{errors[field.name]}</span>
                    )}
                  </div>
                ))}

                 <div>
                  <label>Position</label>
                  <input
                    type="text"
                    name="position"
                    value={formData.position}
                  readOnly={selectedPosition !== ""} // read-only only when user clicked from job card
                   disabled={selectedPosition !== ""} // disable typing if pre-selected
                    onChange={handleChange}
                  />
                </div>

                {/* Other fields */}
                <label>Current CTC</label>
                <input
                  type="text"
                  name="currentCTC"
                  value={formData.currentCTC}
                  onChange={handleChange}
                />

                <label>Expected CTC</label>
                <input
                  type="text"
                  name="expectedCTC"
                  value={formData.expectedCTC}
                  onChange={handleChange}
                />

                <label>Work Shift Availability</label>
                <select name="shift" value={formData.shift} onChange={handleChange}>
                  <option value="">Select</option>
                  <option>9 AM to 6 PM</option>
                  <option>9.30 AM to 6.30 PM</option>
                  <option>10 AM to 7 PM</option>
                </select>

                <label>Experience</label>
                <select
                  name="experience"
                  value={formData.experience}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option>Fresher</option>
                  <option>Less than 1 year</option>
                  <option>1 to 2.5 Years</option>
                  <option>2.5 to 4 Years</option>
                  <option>4 to 7 Years</option>
                  <option>7+ Years</option>
                  <option>Internship</option>
                </select>

                <label>How did you find about STS?</label>
                <input
                  type="text"
                  name="source"
                  value={formData.source}
                  onChange={handleChange}
                />

                <label>Reason for switching</label>
                <input
                  type="text"
                  name="reason"
                  value={formData.reason}
                  onChange={handleChange}
                />

                {/* Resume */}
                <label>Upload Resume (PDF/DOC/DOCX)</label>
                <input
                  type="file"
                  name="resume"
                  accept=".pdf,.doc,.docx"
                  onChange={handleChange}
                />
              </div>

              {/* Footer */}
              <div className="cs-form-actions">
                <button
                  type="button"
                  className="cs-btn-outline"
                  onClick={() => setShowForm(false)}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button type="submit" className="cs-btn" disabled={loading}>
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Career;
